import React, { useState } from "react";
import { Autocomplete, Type } from "mesh-component-library";
import { useLocale } from "../../../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../../../app-consts/translations";
import { datadogRum } from "@datadog/browser-rum";

export type LocationInputProps = {
  map: google.maps.Map;
  onClearCustomLocation: () => void;
  onCustomLocationSelection: (data: any) => void;
};

export const LocationInput = ({ map, onClearCustomLocation, onCustomLocationSelection }: LocationInputProps) => {
  const getTranslatedText = useLocale();
  const [suggestions, setSuggestions] = useState([]);

  const formatSuggestionText = (suggestion: google.maps.places.AutocompleteSuggestion) => {
    return {
      text: suggestion.placePrediction.text.text,
      value: suggestion.placePrediction.text.text,
      placeId: suggestion.placePrediction.placeId || "",
    };
  };

  // Add debouncer logic
  const onInputHandler = async (e: any) => {
    const value = e.target.value;
    google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input: value,
    })
      .then((r) => {
        const formattedSuggestions = r.suggestions.map((place) => formatSuggestionText(place));
        setSuggestions(formattedSuggestions);
      })
      .catch((e) => {
        datadogRum.addError("[LocationInput] Error fetching autocomplete suggestions", e);
      });
  };

  const handleSelect = async (e, t) => {
    // When the user clicks X, clear it from redux state
    if (t?.inputValue === "") {
      onClearCustomLocation();
    } else if (t?.selectedItem?.text) {
      const service = new google.maps.places.PlacesService(map);
      service.getDetails({ placeId: t.selectedItem.placeId }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          onCustomLocationSelection(place);
        } else {
          datadogRum.addError("[LocationInput] Error fetching place details", { status, place });
        }
      });
    }
  };

  return (
    <Autocomplete
      clearBtn={true}
      inputMode="search"
      label={<Type size="5xl">Where should we drop off your vehicle?</Type>}
      onChange={handleSelect}
      onInput={onInputHandler}
      placeholder={getTranslatedText(TRANSLATION_CONSTANTS.SELECT_OR_ENTER_TOW_DESTINATION)}
      position="bottom"
      required={true}
      suggestions={suggestions}
      data-testid="locationInput-input"
    />
  );
};
